import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import ReactPixel from 'react-facebook-pixel';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from '@mui/material/styles';
import configureStore from 'store/configureStore';
import StateHelper from 'store/StateHelper';
import App from './App';
import TagManager from 'react-gtm-module'
import { unregister } from './registerServiceWorker';
import theme from './theme';
import 'interceptors';
import { getReactAppConfig } from 'shared/functions';
import { FbPixelId } from 'shared/constants/fb-pixel-id';

dayjs.extend(utc);

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);
StateHelper.setStore(store);

const config = getReactAppConfig();

const tagManagerArgs = {
    gtmId: config.REACT_APP_GTM_CONTAINER_ID,
    auth: config.REACT_APP_GTM_ENV_AUTH,
    preview: config.REACT_APP_GTM_ENV_PREVIEW,
}

TagManager.initialize(tagManagerArgs)

ReactPixel.init(FbPixelId);
ReactPixel.pageView();

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'));

unregister();
